import { createAction } from 'utils'

export const SHOW_SNACKBAR = '@snackbar/SHOW_SNACKBAR'
export const SHOW_STICKY_SNACKBAR = '@snackbar/SHOW_STICKY_SNACKBAR'
export const SHOW_ZIPCODE_SNACKBAR = '@snackbar/SHOW_ZIPCODE_SNACKBAR'
export const HIDE_SNACKBAR = '@snackbar/HIDE_SNACKBAR'

export const constants = {
  SHOW_SNACKBAR,
  SHOW_STICKY_SNACKBAR,
  SHOW_ZIPCODE_SNACKBAR,
  HIDE_SNACKBAR
}

export const showSnackbar = createAction(SHOW_SNACKBAR)

/**
 * Shows a message that stays until the user closes it, signs in again or
 * reloads the page.
 *
 * For messages the user did not ask for, such as the end of the session: they
 * arrive while the user is looking somewhere else, so a message that hides
 * itself is a message nobody reads.
 */
export const showStickySnackbar = createAction(SHOW_STICKY_SNACKBAR)

export const showZipcodeSnackbar = createAction(SHOW_ZIPCODE_SNACKBAR)
export const hideSnackbar = createAction(HIDE_SNACKBAR)

export default {
  showSnackbar,
  showStickySnackbar,
  showZipcodeSnackbar,
  hideSnackbar
}
